import type { InjectionKey, Ref } from 'vue';

export const autocompleteInjectionKey = Symbol('autocomplete') as InjectionKey<{
  activeOptionKey: Ref<unknown>;
  selectedOptionKey: Ref<unknown>;
  selectOption: (value: unknown) => void;
}>;
